import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import matchSorter from "match-sorter";

import * as modalActions from "../../actions/modalActions";
import * as contractActions from "../../actions/contractActions";
import * as projectActions from "../../actions/projectActions";
import * as departmentActions from "../../actions/departmentActions";
import * as customerActions from "../../actions/customerActions";
import * as userActions from "../../actions/userActions";

import ProjectService from "../../services/projectService";

import HeaderWrapper from "../common/HeaderWrapper";
import ProjectList from "../project/ProjectList";
import ProjectForm from "../project/ProjectForm";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";
import { customToast as toast } from "../../utils";

class CustomerProjectsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { search: "", projects: [], pageSize: 5 };
  }

  componentDidMount = async () => {
    const { users, departments, actions } = this.props;

    this.loadProjects();
    if (!users.length) actions.loadUsers();
    if (!departments.length) actions.loadDepartments();
  };

  onChangePageSize = (size) => {
    this.setState({ pageSize: size });
  };

  onClickAdd = () => {
    this.setState({ adding: true });
    this.props.actions.showModalSuccess("projectDetailsModal");
  };

  onClickView = (project) => {
    this.setState({ adding: false });
    this.props.actions.getProject(project, true);
  };

  onClickFullViewProject = (id) => {
    this.props.history.push(`/app/projects/${id}`);
  };

  onClickDelete = (projectId) => {
    this.props.actions.requestProjectId(projectId);
  };

  onClickFavorite = (projectId) => {
    this.props.actions.updateFavorites(this.props.auth.user, projectId);
  };

  handleDelete = () => {
    this.props.actions.deleteProject(this.props.projectToDelete);
  };

  handleAdd = (project) => {
    this.props.actions.createProject(project, false);
  };

  handleSave = async (project) => {
    await this.props.actions.updateProject(project, false);
    await this.loadProjects();
  };

  // sort projects by status order for customer view page -RW 9/29/20
  sortProjects = async (projectsIn) => {
    const sorter = (a, b) => {
      if (a.project_status.order < b.project_status.order) {
        return -1;
      }
      if (a.project_status.order > b.project_status.order) {
        return 1;
      }
      return 0;
    };
    // lets avoid mutating arrays in place in the future
    projectsIn.sort(sorter);
    this.setState({ projects: projectsIn });
  };

  loadProjects = async () => {
    try {
      const { match } = this.props;
      const projects = await ProjectService.loadProjects({
        customer: match.params.id
      });
      this.setState({ projects });
      this.sortProjects(projects);
    } catch (err) {
      toast.error("Error loading customer projects.");
    }
  };

  // only handles search bar
  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const {
      customer,
      codes,
      contracts,
      project,
      users,
      departments,
      auth,
      saving,
      isMobile
    } = this.props;
    const { projects, search, adding } = this.state;

    const projectForm = (
      <ProjectForm
        project={adding ? {} : project}
        customers={[customer]}
        customer={customer._id}
        contracts={contracts}
        codes={codes}
        users={users}
        departments={departments}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        adding={adding}
        saving={saving}
        editing={auth.maxRole > 2000}
        preventEdit={auth.maxRole < 3000}
      />
    );

    return (
      <div id="projects">
        <HeaderWrapper
          breadcrumbs={[{ label: "Projects" }]}
          onClickAdd={auth.maxRole > 2000 && this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <ProjectList
            clientSide
            auth={auth}
            defaultPageSize={5}
            projects={matchSorter(projects, search, {
              keys: [
                "number",
                "name",
                "call_type.label",
                "customer.name",
                "project_manager.full_name",
                "entered_date",
                "project_status.label"
              ]
            })}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            isMobile={isMobile}
            onClickFavorite={this.onClickFavorite}
            onClickFullView={this.onClickFullViewProject}
          />
        </div>
        <Modal
          id="projectDetailsModal"
          title={adding ? "Add Project" : project.name}
          body={projectForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="projectDeleteModal"
          title="Delete Project"
          body="Are you sure you want to delete this project?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </div>
    );
  }
}

CustomerProjectsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  codes: PropTypes.array.isRequired,
  users: PropTypes.array,
  projectToDelete: PropTypes.string,
  match: PropTypes.object,
  customer: PropTypes.object,
  contracts: PropTypes.array,
  project: PropTypes.object,
  departments: PropTypes.array,
  auth: PropTypes.object,
  saving: PropTypes.bool,
  isMobile: PropTypes.bool,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    departments: state.reducers.departments,
    customer: state.reducers.customer,
    contracts: state.reducers.contracts,
    project: state.reducers.project,
    projectToDelete: state.reducers.projectToDelete,
    saving: state.reducers.savingProject,
    users: state.reducers.users,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...projectActions,
        ...customerActions,
        ...contractActions,
        ...departmentActions,
        ...userActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CustomerProjectsPage)
);
